module.exports = __webpack_public_path__ + "static/media/schody21 - schody drewniane lakierowane z podestem.6d5c5916.jpg";